<div class="modal fade in upload-file-modal" [ngClass]="{'show': documentsService.isUploadFileModalShow}"> <!-- inmodal-->
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="documentsService.hideUploadFileModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <div class="title-block">
                    <h4 class="modal-title">Upload File</h4>
                    <small>Max File Size: 25 MB</small>
                </div>
            </div>
            <div class="modal-body">
                <ng-container *ngIf="visibleSteps.length > 1">
                    <div class="row m-b-sm step-guide">
                        <div class="mtv-primary-color" (click)="changeStep('file-details')">
                            <span>File & Sharing</span>
                        </div>
                        <div class="mtv-primary-color">
                            <span>Notification</span>
                        </div>
                    </div>
                    <div class="row m-b-md step-progress-bar">
                        <div class="col-sm-3" [ngStyle]="{ 'width': calculateCurrentProgressBarLength() }"></div>
                    </div>
                </ng-container>
                <file-details-step
                    [style.display]="currentStep === 'file-details' ? 'block' : 'none'"
                    [submitText]="visibleSteps.length > 1 ? 'Continue' : 'Save'"
                    [isShowPreloader]="showLoader"
                    (notify)="notifyUsersChange($event)"
                    (nextStep)="onNextStepRequest($event)"
                >
                </file-details-step>
                <notification-details-step
                    [style.display]="currentStep === 'notification-details' ? 'block' : 'none'"
                    [files]="files"
                    [isShowPreloader]="showLoader"
                    (nextStep)="onNextStepRequest($event)"
                >
                </notification-details-step>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="documentsService.hideUploadFileModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/documents/upload-file-modal/upload-file-modal.component.html